"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toQueryString = void 0;
/**
 * Stringify an object into a query string
 * @public
 *
 * @param obj - Object to stringify
 *
 * @returns query string
 *
 * @example
 * ```ts
 * const result = toQueryString({a: 'a', b: 'b'});
 * console.log(result);
 * // -> a=a&b=b
 * ```
 */
function toQueryString(obj) {
    return Object.entries(obj)
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
        .filter(Boolean)
        .join('&');
}
exports.toQueryString = toQueryString;
//# sourceMappingURL=to-query-string.js.map